export default "__VITE_ASSET__BsIhX9EE__"